import { TICKET_ORIGINS } from '../../utils/ticketDraft'
import '../../styles/ticket-form.css'

/**
 * Selector de la plataforma / sistema de origen.
 *
 * @component
 * @param {Object} props
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {'select'|'cards'} [props.variant='select'] - Lista desplegable o
 *   tarjetas con ícono (más fácil de recorrer en el modo paso a paso).
 * @param {boolean} [props.invalid=false]
 * @returns {JSX.Element}
 */
const OriginPicker = ({ value, onChange, variant = 'select', invalid }) => {
  if (variant === 'cards') {
    return (
      <div className="at-origin-grid" role="radiogroup" aria-label="Plataforma">
        {TICKET_ORIGINS.map((origin) => {
          const active = value === origin.value
          return (
            <button
              key={origin.value}
              type="button"
              role="radio"
              aria-checked={active}
              className={`at-origin-card ${active ? 'is-active' : ''}`}
              onClick={() => onChange(origin.value)}
            >
              <i className={`fa-solid ${origin.icon}`} />
              <span>{origin.label}</span>
            </button>
          )
        })}
      </div>
    )
  }

  return (
    <select
      className={`form-select at-input ${invalid ? 'is-invalid' : ''}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Seleccione el sistema</option>
      {TICKET_ORIGINS.map((origin) => (
        <option key={origin.value} value={origin.value}>
          {origin.label}
        </option>
      ))}
    </select>
  )
}

export default OriginPicker
